import {
    GET_OCCUPANTS,
    GET_OCCUPANT_DETAILS,
    CREATE_OCCUPANT,
    UPDATE_OCCUPANT,
    DELETE_OCCUPANT,
    UPLOAD_OCCUPANT_DOCUMENT,
    DELETE_OCCUPANT_DOCUMENT,
    LIST_OCCUPANT_DOCUMENTS
} from '../../index.types';

// Get All Occupants
export const getOccupants = (data) => ({
    type: GET_OCCUPANTS,
    data
});

// Get Occupant Details
export const getOccupantDetails = (data) => ({
    type: GET_OCCUPANT_DETAILS,
    data
});

// Create Occupant
export const createOccupant = (data) => ({
    type: CREATE_OCCUPANT,
    data
});

// Update Occupant
export const updateOccupant = (data) => ({
    type: UPDATE_OCCUPANT,
    data
});

// Delete Occupant
export const deleteOccupant = (data) => ({
    type: DELETE_OCCUPANT,
    data
});

// Occupant documents
// data: { occupant_id, document_type, file (File), onSuccess?, onError? }
export const uploadOccupantDocument = (data) => ({
    type: UPLOAD_OCCUPANT_DOCUMENT,
    data
});

// data: { document_id, occupant_id, onSuccess? }
export const deleteOccupantDocument = (data) => ({
    type: DELETE_OCCUPANT_DOCUMENT,
    data
});

// data: { occupant_id }
export const listOccupantDocuments = (data) => ({
    type: LIST_OCCUPANT_DOCUMENTS,
    data
});
